import { PRODUCTS_URL, UPLOAD_URL } from "../constants.js"
import { apiSlice } from "./apiSlice.js"

export const productsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProducts: builder.query({
            query: ({ keyword, sort, min, max, pageNumber, itemType, language }) => ({
                url: PRODUCTS_URL,
                params: {
                    keyword,
                    sort,
                    min,
                    max,
                    pageNumber,
                    itemType,
                    language,
                }
            }),
            providesTags: ['Products'],
            keepUnusedDataFor: 5
        }),
        getProductList: builder.query({
            query: ({ categories, pageNumber }) => ({
              url: `${PRODUCTS_URL}/list`,
              params: { ...categories, pageNumber },
            }),
            providesTags: ['Products'],
            keepUnusedDataFor: 5,
        }),
        getRandomCategoryProducts: builder.query({
            query: () => ({
                url: `${PRODUCTS_URL}/random`,
                
            }),
            providesTags: ['Products'],
            keepUnusedDataFor: 5,
        }),
        getProductsByUserId: builder.query({
            query: ({ userId, keyword, category, age, sort, pageNumber, creatorCategoryId, itemType, language }) => ({
                url: `${PRODUCTS_URL}/user`,
                params: {
                    userId,
                    keyword,
                    category,
                    age,
                    sort,
                    pageNumber,
                    creatorCategoryId,
                    itemType,
                    language,
                },
            }),
            providesTags: ['Products'],
            keepUnusedDataFor: 5,
        }),
        getMyCreatorProducts: builder.query({
            query: ({ keyword, category, age, sort, pageNumber, creatorCategoryId, itemType, language }) => ({
                url: `${PRODUCTS_URL}/user/me`,
                params: {
                    keyword,
                    category,
                    age,
                    sort,
                    pageNumber,
                    creatorCategoryId,
                    itemType,
                    language,
                },
            }),
            providesTags: ['Products'],
            keepUnusedDataFor: 5,
        }),
        getProductDetails: builder.query({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/${productId}`,
            }),
            keepUnusedDataFor: 5,
        }),
        getProductDetailsForEdit: builder.query({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/edit/${productId}`,
            }),
            keepUnusedDataFor: 5,
        }),
        createProduct: builder.mutation({
            query: () => ({
                url: PRODUCTS_URL,
                method: 'POST',
            }),
            invalidatesTags: ['Product'],
        }),
        addInquiry: builder.mutation({
            query: ({ productId, comment }) => ({
                url: `${PRODUCTS_URL}/${productId}/inquiries`,
                method: 'POST',
                body: { comment },
            }),
            invalidatesTags: ['Product'],
        }),
        answerInquiry: builder.mutation({
            query: ({ productId, inquiryId, comment }) => ({
                url: `${PRODUCTS_URL}/${productId}/inquiries/`,  
                method: 'PUT',
                body: { inquiryId, comment },
            }),
            invalidatesTags: ['Product'],
        }),
        createProductCreator: builder.mutation({
            query: () => ({
                url: `${PRODUCTS_URL}/create`,
                method: 'POST',
            }),
            invalidatesTags: ['Product'],
        }),
        updateProduct: builder.mutation({
            query: (data) => ({
                url: `${PRODUCTS_URL}/${data.productId}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Products']
        }),
        updateProductCreator: builder.mutation({
            query: (data) => ({
                url: `${PRODUCTS_URL}/edit/${data.productId}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Products']
        }),
        uploadFiles: builder.mutation({
            query: (data) => ({
                url: `${UPLOAD_URL}`,
                method: 'POST',
                body: data,
            })
        }),
        deleteProduct: builder.mutation({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/${productId}`,
                method: 'DELETE',
            })
        }),
        deleteProductCreator: builder.mutation({
            query: (productId) => ({
                url: `${PRODUCTS_URL}/delete?id=${productId}`, // Pass ID as query parameter
                method: 'DELETE',
            }),
            invalidatesTags: ['Products'],
        }),
        createReview: builder.mutation({
            query: (data) => ({
                url: `${PRODUCTS_URL}/${data.productId}/reviews`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Product']
        }),
        getTopProducts: builder.query({
            query: () => ({
                url: `${PRODUCTS_URL}/top`,
            }),
            keepUnusedDataFor: 5,
        })
    }),
})

export const { useGetProductsQuery,
      useGetRandomCategoryProductsQuery,
      useGetProductListQuery,
      useGetProductsByUserIdQuery,
      useGetMyCreatorProductsQuery,
      useGetProductDetailsQuery,
      useGetProductDetailsForEditQuery,
      useCreateProductMutation,
      useCreateProductCreatorMutation,
      useUpdateProductMutation,
      useUpdateProductCreatorMutation,
      useUploadFilesMutation,
      useDeleteProductMutation,
      useDeleteProductCreatorMutation,
      useCreateReviewMutation,
      useAddInquiryMutation,
      useAnswerInquiryMutation,
      useGetTopProductsQuery,
     } = productsApiSlice
